// Giving Slider
var giving_swiper_thumbs = new Swiper('.giving-slider-thumbs', {
  spaceBetween: 15,
  slidesPerView: 2,
  loop: false,
  freeMode: false,
  grabCursor: true,
  watchSlidesProgress: true,
  breakpoints: {
    720: {
      slidesPerView: 5,
    },
  },
});

var giving_swiper = new Swiper('.giving-slider', {
  loop: false,
  autoHeight: true,
  thumbs: {
    swiper: giving_swiper_thumbs,
  },
  breakpoints: {
    720: {
      autoHeight: true,
    },
  },
});